export const WagonSelectionWidgetId = 'WagonSelectionWidget';

export enum WagonSelectionWidgetAttributes {
  DISABLED = 'wagonSelectionDisabled',
  ITEMS = 'wagonSelectionItems',
  INITIAL_VALUE = 'wagonSelectionInitialValue',
}
